import gql from 'graphql-tag';

const DEVICE_COUNT = gql`
  query Query {
    deviceDashboard {
      inQc
      created
      qcPass
      qcFail
      readyForDeployment
      deployed
      inRCA
      decomissioned
    }
  }
`;

export default DEVICE_COUNT;
